var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('textarea',{attrs:{"id":"ck-editor","name":"ckeditor","rows":"10","cols":"80"}})])])
}]

export { render, staticRenderFns }